import { facadeApi } from 'api'

export const fetchPageBuilderAsset = ({ assetId }: { assetId: string }) =>
  facadeApi.get<Blob>(`/assets/page-builder/${assetId}`, { responseType: 'blob' })
